import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { useEffect } from "react";

import { setFieldValidationState } from "../slices/formSlice";

import { hideAlert } from "../slices/alertSlice";
import { clearForm } from "../slices/formSlice";
import { setShowAlert } from "../slices/alertSlice";
import { setFieldError } from "../slices/formSlice";
import { clearFieldError } from "../slices/formSlice";

export const useFormSubmit = ({formId, onSubmit, successMessage, reload, fields, error}) => {
    const dispatch = useDispatch();
    const formValues = useSelector((state) => state.form.forms[formId]?.values || {});

    const isEmptyValue = (val) =>
        val === null ||
        val === undefined ||
        (typeof val === "string" && val.trim() === "") ||
        (Array.isArray(val) && val.length === 0) ||
        (typeof val === "object" && !Array.isArray(val) && Object.keys(val).length === 0);

    useEffect(() => {
        const savedItem = localStorage.getItem("formAlert");
        if (savedItem) {
            dispatch(setShowAlert(JSON.parse(savedItem)));
            localStorage.removeItem("formAlert");
        }
    }, [dispatch]);

    useEffect(() => {
        if (error) {
            const errorMessage = showError(error);
            dispatch(setShowAlert({ type: "failure", messages: errorMessage, context: `${formId}-form` }));
        }
    }, [dispatch, formId, error]);

    const showError = (error) => {
        let errorMessage;
        if (typeof error === "string") {
            errorMessage = error;
        } else if (error?.message) {
            errorMessage = error.message;
        } else if (error?.errors) {
            errorMessage = Object.values(error.errors).flat().join(", ");
        }
        return errorMessage;
    };

    const handleSubmit = async () => {
        dispatch(hideAlert());

        fields.forEach((field) => {
            if (!field.validationRules?.required) return;

            const value = formValues[field.name];
            const isEmpty = isEmptyValue(value);

            dispatch(setFieldValidationState({
                formId,
                fieldName: field.name,
                isEmpty
            }));

            if (isEmpty) {
                dispatch(setFieldError({ formId, fieldName: field.name, error: "Поле обязательно" }));
            } else {
                dispatch(clearFieldError({ formId, fieldName: field.name }));
            }
        });

        const emptyFields = fields
            .filter((field) => field.validationRules?.required)
            .filter((field) => isEmptyValue(formValues[field.name]))
            .map((field) => field.label);

        if (emptyFields.length > 0) {
            dispatch(setShowAlert({ type: "failure", messages: `Заполните обязательные поля: ${emptyFields.join(", ")}` }));
            return;
        }

        try {
            await onSubmit(formValues);

            dispatch(clearForm({ formId }));
            const alertData = { type: "success", messages: successMessage, context: `${formId}-form` };
            dispatch(setShowAlert(alertData));
            if (reload) {
                localStorage.setItem("formAlert", JSON.stringify(alertData));
                window.location.reload();
            }
        } catch (error) {
            const errorMessage = showError(error);
            console.log("Caught error:", error);
            console.log("Parsed error message (catch):", errorMessage);
            dispatch(setShowAlert({ type: "failure", messages: errorMessage, context: `${formId}-form` }));
        }
    };

    return { handleSubmit };
}